module.exports = __webpack_public_path__ + "static/img/CaoDacNhat.bb271a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CaoDacNhat.png
// module id = 9GrM
// module chunks = 1